import Modal from "@/components/Modal";
import Button from '@components/DesignLibrary/Button';
import CustomSelect from '@components/FormFields/CustomSelect';
import { useState } from "react";
import { DEFAULT_CURRENCY } from '@typings/common';
import * as format from '@format';
import { ApiDefinition } from '@noodleApi';
import * as ApiModels from '@typings/api-models';
import commonStyles from '@modals/ModalsCommon.module.scss';

const DIFFERENCE_ACTION = [
  {
    key: 'carryForward',
    title: 'Add to the next month installment',
    value: 'carryForward',
  },
  {
    key: 'split',
    title: 'Split among upcoming installments',
    value: 'split',
  },
];

type InstallmentDataProps ={
  invoice: ApiDefinition['/invoices/{id}']['GET']['response'];
  onClose: () => void;
  handleSubmit: (data:{
    differenceAction:string;
    paymentPlanId:string,
    paymentPlanPaymentId: string,
  }) => Promise<void>;
  installmentData: Pick<ApiModels.PaymentPlanPayment, 'id' | 'expectedAmount' | 'paymentPlanId'>;
  fetchingState: {
    isFetching: boolean;
    isFetched: boolean;
    fetchingTime: number | null;
}
};

const DeleteInstallmentModal:React.FC<InstallmentDataProps> = ({onClose, handleSubmit, installmentData, invoice, fetchingState}) => {
  const [differenceAction, setDifferenceAction] = useState(DIFFERENCE_ACTION[0].value);
  return (
    <Modal
      hideBottomInset
      title='Edit Installment'
      onClose={onClose}
    >
      <div className={commonStyles.container} style={{ gap: 16, paddingTop: 40 }}>
        <CustomSelect label={`Choose the ${format.price.withCurrency(installmentData?.expectedAmount, invoice?.currency ?? DEFAULT_CURRENCY)} difference action`} value={differenceAction} id='differenceAction' onChange={newAction => setDifferenceAction(newAction)} options={DIFFERENCE_ACTION} />
        <Button
          variant='destructive'
          size='md'
          fullWidth
          loading={fetchingState.isFetching}
          onClick={() => {
            handleSubmit({
              differenceAction,
              paymentPlanId:installmentData?.paymentPlanId,
              paymentPlanPaymentId: installmentData?.id,
            });
          }}
        >
              Delete
        </Button>
      </div>
    </Modal>
  );

};
export default DeleteInstallmentModal;